var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showType == 2
        ? _c("div", { staticClass: "bg-img" }, [
            _c(
              "div",
              { staticClass: "iframe-box", attrs: { id: "iframeBox" } },
              [
                _c("iframe", {
                  staticStyle: {
                    width: "375px",
                    height: "100%",
                    "margin-left": "11px",
                  },
                  attrs: {
                    title: "",
                    src: _vm.previewUrl,
                    id: "materialList",
                    seamless: "seamless",
                    name: "materialList",
                  },
                  on: { load: _vm.loadIframe, click: function () {} },
                }),
              ]
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-box",
              attrs: {
                src: require("../../assets/imgs/mobile-bg.png"),
                alt: "",
              },
            }),
          ])
        : _c(
            "el-drawer",
            {
              attrs: {
                title: "装修预览",
                size: "500px",
                direction: "rtl",
                visible: _vm.visibleDrawer,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visibleDrawer = $event
                },
                close: _vm.closeDrawer,
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "bg-img" }, [
                  _c(
                    "div",
                    { staticClass: "iframe-box", attrs: { id: "iframeBox" } },
                    [
                      _c("iframe", {
                        staticStyle: {
                          width: "375px",
                          height: "100%",
                          "margin-left": "11px",
                        },
                        attrs: {
                          title: "",
                          src: _vm.previewUrl,
                          id: "materialList",
                          seamless: "seamless",
                          name: "materialList",
                        },
                        on: { load: _vm.loadIframe, click: function () {} },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "img-box",
                    attrs: {
                      src: require("../../assets/imgs/mobile-bg.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }